import { render, staticRenderFns } from "./Suggestion.vue?vue&type=template&id=0aaeec81&scoped=true&"
import script from "./Suggestion.vue?vue&type=script&lang=js&"
export * from "./Suggestion.vue?vue&type=script&lang=js&"
import style0 from "./Suggestion.vue?vue&type=style&index=0&id=0aaeec81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaeec81",
  null
  
)

export default component.exports